import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  makeStyles
} from '@material-ui/core';
import {
  Event,
  PlayCircleFilled,
  Schedule,
  CheckCircle
} from '@material-ui/icons';
import { getMeetingStatus } from '../utils/meetingUtils';

const useStyles = makeStyles((theme) => ({
  statsCard: {
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
    },
  },
  statsIcon: {
    fontSize: 40,
    marginBottom: theme.spacing(1),
  },
  statsNumber: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  statsLabel: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  inProgressCard: {
    background: 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)',
    color: 'white',
    '& .MuiTypography-root': {
      color: 'white !important',
    },
  },
  notStartedCard: {
    background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)',
    color: 'white',
    '& .MuiTypography-root': {
      color: 'white !important',
    },
  },
  endedCard: {
    background: 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)',
    color: 'white',
    '& .MuiTypography-root': {
      color: 'white !important',
    },
  },
  totalCard: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    '& .MuiTypography-root': {
      color: 'white !important',
    },
  },
}));

const MeetingStats = ({ meetings }) => {
  const classes = useStyles();

  const stats = React.useMemo(() => {
    const total = meetings.length;
    let inProgress = 0;
    let notStarted = 0;
    let ended = 0;
    let organizersJoined = 0;

    meetings.forEach((meeting) => {
      const status = getMeetingStatus(
        meeting.scheduledStart,
        meeting.scheduledEnd,
        meeting.timeZone
      );

      switch (status) {
        case 'in_progress':
          inProgress++;
          break;
        case 'not_started':
          notStarted++;
          break;
        case 'ended':
          ended++;
          break;
      }

      if (meeting.organizer.hasJoined) {
        organizersJoined++;
      }
    });

    return {
      total,
      inProgress,
      notStarted,
      ended,
      organizersJoined,
      joinRate: total > 0 ? Math.round((organizersJoined / total) * 100) : 0,
    };
  }, [meetings]);

  const statsData = [
    {
      label: 'Total Reuniones',
      value: stats.total,
      icon: Event,
      className: classes.totalCard,
    },
    {
      label: 'En Curso',
      value: stats.inProgress,
      icon: PlayCircleFilled,
      className: classes.inProgressCard,
    },
    {
      label: 'No Iniciadas',
      value: stats.notStarted,
      icon: Schedule,
      className: classes.notStartedCard,
    },
    {
      label: 'Finalizadas',
      value: stats.ended,
      icon: CheckCircle,
      className: classes.endedCard,
    },
  ];

  return (
    <Grid container spacing={3} style={{ marginBottom: 24 }}>
      {statsData.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card className={`${classes.statsCard} ${stat.className}`}>
            <CardContent>
              <Box textAlign="center">
                {React.createElement(stat.icon, { className: classes.statsIcon })}
                <Typography className={classes.statsNumber}>
                  {stat.value}
                </Typography>
                <Typography className={classes.statsLabel}>
                  {stat.label}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export { MeetingStats };
export default MeetingStats;